<template lang="pug">
#hero-header
    .logo
        .svg: LogoSvg(:count="count")
        img.catchcopy(
            src="@/assets/img/text/1.svg",
            :class="{ '-active': count > 60 }",
            alt="欲しいのは、リュクスな暮らし"
        )
        img.flower(src="@/assets/img/01.png", :class="{ '-active': count > 70 }")
    //- a.link(href="https://renodeluxe.jp/gallery/")
    //-     img(src="@/assets/img/02.png")
</template>

<script>
import { setInterval, clearInterval } from 'timers';
import LogoSvg from './logo-svg';
export default {
  name: 'hero-header',
  data: function() {
    return {
      count: 0,
      timeObj: null,
    };
  },
  mounted: function() {
    this.timeObj = setInterval(() => {
      this.count++;
      // eslint-disable-next-line
      //console.log(this.count);
    }, 40);
  },
  watch: {
    count: function() {
      if (this.count > 120) {
        clearInterval(this.timeObj);
      }
    },
  },
  methods: {
    countUp: function() {
      this.count++;
    },
  },
  props: {
    msg: String,
  },
  components: {
    LogoSvg,
  },
};
</script>

<style lang="scss" scoped>
#hero-header {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  > .logo {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  > .logo > .svg {
    transform: rotate(-5deg) translateX(-6%);
    width: 330px;

    @media #{$phone} {
      width: 240px;
    }
    > svg {
      width: 100%;
      height: 100%;
    }
  }

  > .logo > .catchcopy {
    width: 240px;
    transform: translateY(-10%);
    opacity: 0;
    transition: 1s;

    &.-active {
      opacity: 1;
    }
  }
  _:-ms-lang(x)::-ms-backdrop,
  > .logo > .catchcopy {
    // IE11対応
    transform: translateY(-80%);
  }

  > .logo > .flower {
    width: 115px;
    height: auto;
    transform: translate(80%, -40%) rotate(-8deg);
    opacity: 0;
    transition: 1s;

    @media #{$pc} {
      width: 12%;
      transform: translate(90%, -50%);
    }

    &.-active {
      opacity: 1;
      transform: translate(80%, -40%) rotate(0deg);

      @media #{$pc} {
        transform: translate(90%, -50%);
      }
    }
  }

  _:-ms-lang(x)::-ms-backdrop,
  > .logo > .flower {
    // IE11対応
    height: 100%;
  }
  > .link {
    width: 96px;
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translateX(-50%);

    > img {
      width: 100%;
    }
  }
}
</style>
